export default {
	loading: {
		partIsLoading: "Bauteil wird geladen...",
		partIsSaving: "Bauteil wird gespeichert...",
		anchorFaceIsChanging: "Oberseite wird gewechselt...",
		featureIsSetting: "Feature wird gesetzt...",
		whileMarkingFeaturesMessage: "Features werden markiert...",
		imageAlt: "Wird geladen...",
	},
	errors: {
		modelCannotBeShown: "Modell kann nicht angezeigt werden. Bitte wenden Sie sich an unser Helpdesk.",
		saveFailedTitle: "Fehler beim Speichern",
		changeCouldNotBeMade: "Die Änderung konnte nicht durchgeführt werden. Wenden Sie sich an unser Helpdesk.",
		messageCouldNotBeConfirmed: "Meldung konnte nicht bestätigt werden.",
		weldlineDefinitionError:
			"Fehler beim Definieren der Schweißnähte. Bitte wenden Sie sich an info@blexon.com",
		modificationFailedShortDescription:
			"Die gewünschte Bearbeitung des Modells konnte nicht abgeschlossen werden. " +
			"Bitte senden Sie den Artikel zur kostenlosen Überprüfung an unser Helpdesk.",
		featureCreationFailedTitle: "Feature konnte nicht erstellt werden",
		editingErrorTitle: "Fehler bei der Bearbeitung",
		modelEditingFailedTitle: "Fehler beim Bearbeiten des Modells",
		rollDirectionAdjustFailedTitle: "Schliffrichtung konnte nicht angepasst werden",
		rollDirectionAngleAdjustFailedTitle: "Winkel der Schliffrichtung konnte nicht angepasst werden",
		rollDirectionSetFailed:
			"Schliffrichtung konnte nicht gesetzt werden. Bitte verwenden Sie eine Linie an einer " +
			"Aussenkontur oder einem Ausschnitt.",
	},
	devMode: "DEV-MODE",
	panels: {
		editor: "Editor",
		mode: "Mode",
		article: "Artikel",
		messages: "Messages",
		features: "Features",
		structure: "Struktur",
	},
	processType: {
		cut: "Schneiden",
		cylindicBend: "Biegung",
		engrave: "Gravieren",
		formCountersink: "Senkung",
		formExtrudedThread: "Durchzug mit Gewinde",
		formScrewThread: "Gewindeformen",
		weld: "Schweißen",
		drillCylinderHeadBoltHole: "Zylindersenkung",
		pressJoin: "Einpressung",
		none: "Kein Prozess",
		unknown: "Unbekannter Prozess",
	},
	editorMode: {
		featureMode: "Bearbeitung",
		measuringMode: "Messen",
		rollDirectionMode: "Schliffrichtung",
		weldMode: "Schweißen",
		none: "Kein Modus",
	},
	featureType: {
		undefined: "Undefiniert",
		anchorFace: "Oberseite",
		bottomFace: "Unterseite",
		sideFace: "Aussenseite",
		bend: "Biegelinie",
		hole: "Runder Ausschnitt",
		cutout: "Ausschnitt",
		screwThread: "Gewinde",
		countersink: "Senkung",
		extrudedThread: "Durchzug",
		engraving: "Gravur",
		invalid: "Ungültig",
		weldline: "Schweißnaht",
		cylinderHeadBoltHole: "Schweißnaht",
		pressJoin: "Einpressung",
		unknown: "Unbekanntes Feature",
	},
};
